<template>
  <div class="bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <div class="search-wrap flex items-center">
      <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入管道编码"
        clearable
        class="ml-5px"
      ></el-input>
      <el-button @click="searchHandler" size="mini" type="primary" class="ml-5px">搜索</el-button>
    </div>
    <el-table
      ref="markerTable"
      :data="tableData"
      :row-key="(row) => row.id"
      class="markerTable mt-10px"
      height="calc(100% - 75px)"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      v-loading="tableLoading"
      highlight-current-row
      @row-click="checkDetail"
    >
      <el-table-column show-overflow-tooltip prop="code" label="管道编码"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="管道名称"></el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'

const threeDimensionsApi = new ThreeDimensionsApi()

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      keyWord: null,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
    }
  },
  watch: {},
  computed: {
    // 广西石化管线类别代码
    gxPipeClassCode() {
      return Wiz.globalSettings.globalConfig?.gxPipeClassCode || 'A06_0601'
    },
  },
  async created() {
    this.getTableData()
  },
  methods: {
    // 获取管线表数据
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await threeDimensionsApi.getTagList({
        body: {
          code: this.keyWord ? `%${this.keyWord}%` : null,
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          classCode: this.gxPipeClassCode,
        },
      })
      this.tableLoading = false
      if (!err && res && res.code === '200' && res.data?.items) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      }
    },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    async checkDetail(row) {
      this.$emit('transferEvent', {
        toCom: { code: 'AssociatedMaterial', origin: 'ValveManagement', name: '关联物料' },
        type: 'mainComponent',
        props: {
          ...row,
        },
      })
      const itemInfo = await this.player.Native.ModelTree.getItemByCode(row.code)
      if (itemInfo?.item) {
        this.player.Native.ModelTree.setSelectItem(itemInfo.item)
        this.player.Native.Camera.moveToItem(itemInfo.item, 2)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.search-wrap {
  ::v-deep .el-button {
    height: 28px !important;
    border-radius: 5px !important;
  }
  ::v-deep .el-input--small .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
  }
}
.markerTable {
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
</style>
